<template>
  <!-- eslint-disable vue/require-v-for-key -->
  <table class="table-hover reports-table weekly-limits-table table">
    <tbody class="thead">
      <tr>
        <template v-if="walker.sub_show">
          <th>{{ walker.sub_label }}</th>
        </template>
        <th>Time spent</th>
        <th>Weekly limit</th>
        <th>Percentage used</th>
        <th>Remaining</th>
      </tr>
    </tbody>

    <template v-for="(section, index) in tableData.sections">
      <tbody
        v-if="tableIsTeam"
        :key="`grouping-${index}`"
        class="grouping-header"
      >
        <tr>
          <th>
            <template v-if="walker.main_type === 'week'">
              {{ formatDateLabel(section.main) }}
            </template>

            <template v-else-if="walker.main_type === 'user'">
              <div class="d-flex align-items-center gap-4">
                <ReportTableAvatar
                  :user-id="section.main_id"
                  :url="section.rows[0].record.avatar_url"
                />
                {{ section.main }}
              </div>
            </template>

            <template v-else>
              {{ section.main }}
            </template>
          </th>
          <th
            v-for="col in 4"
            :key="col"
          ></th>
        </tr>
      </tbody>
      <tbody class="tbody">
        <tr
          v-for="(row, index) in section.rows"
          :key="index"
        >
          <template v-if="walker.sub_show">
            <td v-if="row.sub_show_data">
              <template v-if="walker.sub_type === 'user'">
                <ReportTableAvatar
                  :user-id="row.record.sub_id"
                  :url="row.record.avatar_url"
                />
                {{ row.record.sub }}
              </template>

              <template v-else-if="walker.sub_type === 'project'">
                <ReportTableAvatarInitial :text="row.record.sub" />
                {{ row.record.sub }}
              </template>

              <template v-else-if="walker.sub_type === 'week'">{{ formatDateLabel(row.record.sub) }}</template>

              <template v-else>{{ row.record.sub }}</template>
            </td>
            <td v-else></td>
          </template>
          <td>{{ row.record.used | formatDuration('auto', null, false, true) }}</td>
          <td>{{ (row.record.allowed_seconds || 0) | formatDuration('auto', null, false, true) }}</td>
          <td class="percentage-cell">
            <div class="progress-time-text">
              <ReportTableProgressBar
                :tracked="row.record.used"
                :total="row.record.allowed_seconds"
                class="widget-progress"
              />
            </div>
            {{ row.record.used | percentage(row.record.allowed_seconds) }}
          </td>
          <td>{{ row.record.remaining | formatDuration('auto', null, false, true) }}</td>
        </tr>
      </tbody>
    </template>
  </table>
  <!-- eslint-enable vue/require-v-for-key -->
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'WeeklyLimitsReportTable',
  props: {
    tableData: Object,
  },
  computed: {
    ...mapGetters(['tableIsTeam', 'walker', 'startWeekOn']),
    ...mapState(['organization']),
  },
  methods: {
    formatDateLabel(value) {
      const startDay = toMomentIsoWeekday(this.startWeekOn);
      const currDate = TimeUtils.parse_internal_date(value);
      const startDate = currDate.startOfIsoWeek(startDay);

      return `${TimeUtils.format_date(startDate)} - ${TimeUtils.format_date(startDate.add(6, 'days'))}`;
    },
  },
};
</script>
